import fetch from "../../uilts/request.js";

export default {
    getData() {
        return fetch.post("/HomeDiy/getData")
    },
    save(data) {
        return fetch.post("/HomeDiy/save", data)
    },
    submitMyDiy(data) {
        return fetch.post("/HomeDiy/submitMyDiy", data)
    },
    getMyDiy() {
        return fetch.post("/HomeDiy/getMyDiy")
    },

    async getTarBarList() {
        return await fetch.post("/HomeDiy/getTarBarList")
    },

    async saveTarBarList(data) {
        return await fetch.post("/HomeDiy/saveTarBarList",data)
    }

}
